import React, { Component } from 'react'
import Cookies from 'js-cookie'
import { Link, Redirect } from 'react-router-dom'
import { XCircleIcon } from '@heroicons/react/solid'
import { CheckCircleIcon } from '@heroicons/react/solid'
import { CalendarIcon } from '@heroicons/react/solid'
import { TicketIcon } from '@heroicons/react/solid'
import { ClipboardListIcon } from '@heroicons/react/solid'
import { LockClosedIcon } from '@heroicons/react/solid'
import { ChevronRightIcon } from '@heroicons/react/solid'
import { LogoutIcon } from '@heroicons/react/solid'
import { ShareIcon } from '@heroicons/react/solid'
import tools from '../../tools'
import Skeleton from '../UI/Skeleton'
import ShareApp from './ShareApp'

class Membres extends Component
{
	constructor(props)
	{
		super(props)
		this.birthdayDayRef = React.createRef()
		this.birthdayMonthRef = React.createRef()
		this.birthdayYearRef = React.createRef()
		this.flashTimer = null
		this.state = {
			deposit: null,
			config_pms: undefined,
			saving: false,
			form1: {
				firstname: this.props.user.firstname,
				lastname: this.props.user.lastname,
				email: this.props.user.email,
				birthday: this.props.user.birthday || '',
				civility: (this.props.user.civility) ? this.props.user.civility : '',
				lang: this.props.user.langage
			},
			redirect: false,
			inventory: false,
			user: this.props.user,
			error: null,
			success: null,
			show_share: false
		}
	}

	openShare = () => {
		this.setState({ show_share: true })
	}

	closeShare = () => {
		this.setState({ show_share: false })
	}

	componentDidMount()
	{
		this.props.updateLogs(this.props.history.location.pathname, 'Membres')
		this.props.updateShell('profile', true, this.props.history.location.pathname)
		if (this.props.config_pms)
			this.setState({ config_pms: this.props.config_pms.values })
		else
		{
			this.props.fetchConfigPms()
			.then(config_pms => {
				this.setState({ config_pms: config_pms.values })
			})
			.catch(err => {
				this.setErrorMsg("Une erreur s'est produite")
				console.log(err)
			})
		}
		this.props.fetchNotifications()
		if (this.props.config_inventory)
			this.setInventory(this.props.config_inventory)
		else if (this.props.config_inventory === null)
		{
			this.props.fetchConfigInventory()
			.then(config_inventory => {
				this.setInventory(config_inventory)
			})
			.catch(err => {
				console.log(err)
			})
		}
		if (this.props.config_deposit)
			this.setDeposit(this.props.config_deposit)
		else if (this.props.config_deposit === null)
		{
			this.props.fetchConfigDeposit()
			.then(config_deposit => {
				this.setDeposit(config_deposit)
			})
			.catch(err => {
				console.log(err)
			})
		}
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps.user !== this.props.user)
		{
			const form1 = {
				firstname: this.props.user.firstname,
				lastname: this.props.user.lastname,
				email: this.props.user.email,
				birthday: this.props.user.birthday || '',
				civility: (this.props.user.civility) ? this.props.user.civility : '',
				lang: this.props.user.langage
			}
			this.setState({ user: this.props.user, form1: form1 })
		}
	}

	componentWillUnmount()
	{
		if (this.flashTimer)
			clearTimeout(this.flashTimer)
	}

	setErrorMsg = (msg) => {
		this.setState({ error: msg, success: null })
	}

	setSuccessMsg = (msg) => {
		if (this.flashTimer)
			clearTimeout(this.flashTimer)
		this.setState({ success: msg, error: null })
		this.flashTimer = setTimeout(() => {
			this.setState({ success: null })
		}, 4000)
	}

	clearFlash = () => {
		this.setState({ error: null, success: null })
	}

	setInventory = (config_inventory) => {
		if (this.state.user.stay && this.state.user.stay.location_category && this && this.state.user.stay.location_category !== '?' &&
			(config_inventory.arrival === true || config_inventory.departure === true))
		{
			const stay_number = (this.state.user.stay && this.state.user.stay.stay_number) ? this.state.user.stay.stay_number : null
			const location_category = (this.state.user.stay && this.state.user.stay.location_category) ? this.state.user.stay.location_category : null
			this.props.fetchInventory(stay_number, "both", location_category)
			.then(inventory => {
				if (inventory !== false)
					this.setState({ inventory: true })
			})
			.catch(err => {
				console.log(err)
			})
		}
	}

	setDeposit = (config_deposit) => {
		if (config_deposit.activate === true && this.props.user && this.props.user.invite !== true)
		{
			this.props.fetchDepositLink()
			.then(deposit => {
				if (deposit !== false && typeof deposit === "object")
					this.setState({ deposit: true })
			})
			.catch(err => console.log("can not fetch deposit link", err))
		}
	}

	handleFirstname = (event) => {
		const form1 = {
			...this.state.form1,
			firstname: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleLastname = (event) => {
		const form1 = {
			...this.state.form1,
			lastname: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleCivility = (event) => {
		const form1 = {
			...this.state.form1,
			civility: event.target.value
		}
		this.setState({ form1: form1 })
	}

	_getBirthdayParts = () => {
		const parts = (this.state.form1.birthday || '').split('/')
		return { day: parts[0] || '', month: parts[1] || '', year: parts[2] || '' }
	}

	_setBirthday = (day, month, year) => {
		const form1 = { ...this.state.form1, birthday: day + '/' + month + '/' + year }
		this.setState({ form1: form1 })
	}

	handleBirthdayDay = (e) => {
		const val = e.target.value.replace(/\D/g, '').slice(0, 2)
		const { month, year } = this._getBirthdayParts()
		this._setBirthday(val, month, year)
		if (val.length === 2) this.birthdayMonthRef.current.focus()
	}

	handleBirthdayMonth = (e) => {
		const val = e.target.value.replace(/\D/g, '').slice(0, 2)
		const { day, year } = this._getBirthdayParts()
		this._setBirthday(day, val, year)
		if (val.length === 2) this.birthdayYearRef.current.focus()
	}

	handleBirthdayYear = (e) => {
		const val = e.target.value.replace(/\D/g, '').slice(0, 4)
		const { day, month } = this._getBirthdayParts()
		this._setBirthday(day, month, val)
	}

	handleBirthdayKeyDown = (e, field) => {
		if (e.key !== 'Backspace') return
		const { month, year } = this._getBirthdayParts()
		if (field === 'month' && month.length === 0) {
			e.preventDefault()
			this.birthdayDayRef.current.focus()
		}
		if (field === 'year' && year.length === 0) {
			e.preventDefault()
			this.birthdayMonthRef.current.focus()
		}
	}

	handleLang = (event) => {
		const form1 = {
			...this.state.form1,
			lang: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleCancel = () => {
		this.setState({
			form1: {
				firstname: this.state.user.firstname,
				lastname: this.state.user.lastname,
				email: this.state.user.email,
				birthday: this.state.user.birthday || '',
				civility: this.state.user.civility || '',
				lang: this.state.user.langage
			},
			error: null,
			success: null
		})
	}

	handleSubmit = (event) => {
		event.preventDefault()
		if (this.state.user.invite === true)
		{
			this.props.updateUser({ ...this.state.user, langage: this.state.form1.lang }, this.props.session)
			return ;
		}
		const from = this.state.user.from
		this.setState({ saving: true })
		if (from === 'webapp')
		{
			const infos = {
				id: this.state.user._id,
				firstname: this.state.form1.firstname,
				lastname: this.state.form1.lastname,
				birthday: this.state.form1.birthday,
				civility: this.state.form1.civility,
				langage: this.state.form1.lang
			}
			this.props.postUpdateUser(infos)
			.then(ret => {
				if (!ret)
					this.setErrorMsg("Une erreur s'est produite")
				else
				{
					this.setSuccessMsg("Les informations ont bien été mises à jours")
					this.props.updateUser(ret, this.props.session)
				}
				this.setState({ saving: false })
			})
			.catch(err => {
				this.setErrorMsg("Une erreur s'est produite")
				this.setState({ saving: false })
				console.log(err)
			})
		}
		else if (from === 'dashboard')
		{
			const updatedUser = { ...this.state.user, langage: this.state.form1.lang }
			this.props.updateUserDashboardLang(updatedUser)
			.then(ret => {
				if (!ret)
					this.setErrorMsg("Une erreur s'est produite")
				else
				{
					this.setSuccessMsg("Les informations ont bien été mises à jours")
					this.props.updateUser(updatedUser, this.props.session)
				}
				this.setState({ saving: false })
			})
			.catch(err => {
				this.setErrorMsg("Une erreur s'est produite")
				this.setState({ saving: false })
				console.log(err)
			})
		}
		else
			this.setState({ saving: false })
	}

	logout = () => {
		this.props.updateUser(null, null)
		Cookies.remove('session', { path: '' })
		localStorage.setItem("session", null)
		this.setState({ redirect: true })
	}

	// Carte de navigation (séjour, réservations, inventaire, caution)
	_navCard = (to, Icon, title, subtitle) => {
		const color1 = '#' + this.props.theme.color1
		return (
			<Link to={to} className="group relative flex items-center gap-4 rounded-xl bg-gray-50 px-4 py-4 transition-colors duration-200 hover:bg-gray-100 focus:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-gray-400 cursor-pointer">
				<span className="flex items-center justify-center h-11 w-11 rounded-full bg-white shadow-sm flex-shrink-0">
					<Icon className="h-6 w-6" style={{ color: color1 }} />
				</span>
				<span className="flex-1 min-w-0">
					<span className="block text-base font-medium text-gray-900">{title}</span>
					<span className="block text-sm text-gray-500 truncate">{subtitle}</span>
				</span>
				<ChevronRightIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
			</Link>
		)
	}

	render() {
		const lang_assets = this.props.lang_assets.account
		const version = localStorage.getItem("version")
		const color1 = '#' + this.props.theme.color1
		const color = { color: '#' + this.props.theme.color2 }
		if (this.state.redirect === true)
			return (<Redirect to="/" />)
		else if (this.state.user === null || this.state.config_pms === undefined)
		{
			return (
				<div className="min-h-4/5-screen">
					<div className="flex justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
						<div className="text-white text-3xl">
							<h1>{lang_assets.title}</h1>
						</div>
					</div>
					<Skeleton variant="list" className="pt-8" />
				</div>
			)
		}
		else
		{
			const user = this.state.user
			let stay = user.stay
			if (!stay)
			{
				stay = {
					location: '...',
					arrival: '...',
					departure: '...'
				}
			}
			const time_now = tools.getTimestamp()
			const langs = this.props.langs
			let langJSX = null
			if (langs.length > 1)
			{
				let langs_available = []
				for (let i = 0; i < langs.length; i++)
				{
					if (langs[i] === "fr")
					{
						langs_available.push({
							value: "fr",
							text: "Français"
						})
					}
					else if (langs[i] === "en")
					{
						langs_available.push({
							value: "en",
							text: "English"
						})
					}
					else if (langs[i] === "de")
					{
						langs_available.push({
							value: "de",
							text: "Deutsch"
						})
					}
					else if (langs[i] === "nl")
					{
						langs_available.push({
							value: "nl",
							text: "Dutch"
						})
					}
					else if (langs[i] === "it")
					{
						langs_available.push({
							value: "it",
							text: "Italiano"
						})
					}
					else if (langs[i] === "es")
					{
						langs_available.push({
							value: "es",
							text: "Español"
						})
					}
					else if (langs[i] === "pt")
					{
						langs_available.push({
							value: "pt",
							text: "Português"
						})
					}
				}
				langJSX = (
					<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
						<label htmlFor="account-lang" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
							Langue
						</label>
						<div className="mt-1 sm:mt-0 sm:col-span-2">
							<select id="account-lang" className="max-w-lg block focus:ring-gray-400 focus:border-gray-400 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md" value={this.state.form1.lang} onChange={this.handleLang}>
								<option value="" disabled>{lang_assets.langage.title}</option>
								{langs_available.map(({ text, value }) => {
									return (<option value={value} key={value}>{text}</option>)
								})}
							</select>
						</div>
					</div>
				)
			}
			let sejoursJSX = this._navCard("/membres/sejours", CalendarIcon, lang_assets.stay.details, lang_assets.stay.stay_subtitle)
			let inventoryJSX = null
			if (this.state.inventory === true)
				inventoryJSX = this._navCard("/inventaire", ClipboardListIcon, lang_assets.stay.inventory, lang_assets.stay.inventory_subtitle)
			let reservationsJSX = null
			if (this.props.features === "premium")
				reservationsJSX = this._navCard("/membres/reservations", TicketIcon, lang_assets.stay.bookings, lang_assets.stay.bookings_subtitle)
			let depositJSX = null
			if (this.state.deposit === true)
				depositJSX = this._navCard("/membres/caution", LockClosedIcon, lang_assets.deposit.title, lang_assets.deposit.subtitle)
			let shareJSX = null
			if (user.client_number)
			{
				shareJSX = (
					<button type="button" onClick={this.openShare} style={{ backgroundImage: 'none', backgroundColor: '#F9FAFB' }} className="w-full text-left group relative flex items-center gap-4 rounded-xl px-4 py-4 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
						<span className="flex items-center justify-center h-11 w-11 rounded-full bg-white shadow-sm flex-shrink-0">
							<ShareIcon className="h-6 w-6" style={{ color: color1 }} />
						</span>
						<span className="flex-1 min-w-0">
							<span className="block text-base font-medium text-gray-900">{lang_assets.share.card_title}</span>
							<span className="block text-sm text-gray-500 truncate">{lang_assets.share.card_subtitle}</span>
						</span>
						<ChevronRightIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
					</button>
				)
			}
			let staysJSX = (
				<div>
					<h2 className="text-base leading-6 font-medium mb-4" style={color}>{lang_assets.stay.title}</h2>
					<div className="space-y-3">
						{sejoursJSX}
						{reservationsJSX}
						{inventoryJSX}
						{depositJSX}
						{shareJSX}
					</div>
				</div>
			)
			// Statut du séjour (à venir / en cours / terminé)
			const calendarDays = (from_time, to_time) => {
				const from = new Date(from_time * 1000)
				const to = new Date(to_time * 1000)
				const from_day = new Date(from.getFullYear(), from.getMonth(), from.getDate())
				const to_day = new Date(to.getFullYear(), to.getMonth(), to.getDate())
				return Math.round((to_day - from_day) / 86400000)
			}
			let arrival_reached = false
			let statusPill = null
			if (stay && stay.arrival_time && stay.departure_time)
			{
				const days_to_arrival = calendarDays(time_now, stay.arrival_time)
				const days_to_departure = calendarDays(time_now, stay.departure_time)
				arrival_reached = (days_to_arrival <= 0)
				let status_label = lang_assets.stay.status_past
				if (days_to_arrival > 0)
				{
					status_label = lang_assets.stay.countdown_before.replace('%d', days_to_arrival)
				}
				else if (days_to_arrival === 0 && time_now < stay.departure_time)
				{
					status_label = lang_assets.stay.countdown_today
				}
				else if (time_now <= stay.departure_time)
				{
					status_label = (days_to_departure <= 0) ? lang_assets.stay.countdown_last : lang_assets.stay.countdown_during.replace('%d', days_to_departure)
				}
				statusPill = (<span className="inline-flex items-center gap-1 mt-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-white bg-opacity-20 text-white">{status_label}</span>)
			}
			let error = null
			if (this.state.error)
			{
				error = (
					<div className="rounded-md bg-red-50 p-4 mt-3">
						<div className="flex">
							<div className="flex-shrink-0">
								<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
							</div>
							<div className="ml-3">
								<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
							</div>
						</div>
					</div>
				)
			}
			let success = null
			if (this.state.success)
			{
				success = (
					<div className="rounded-md bg-green-50 p-4 mt-3">
						<div className="flex">
							<div className="flex-shrink-0">
								<CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
							</div>
							<div className="ml-3">
								<h3 className="text-sm font-medium text-green-600">{this.state.success}</h3>
							</div>
						</div>
					</div>
				)
			}
			let stay_dates = null
			if (this.props.show_stay_dates === true && stay && stay.arrival_time && stay.departure_time)
			{
				const arrival = new Date(stay.arrival_time * 1000)
				let arrival_day = arrival.getDate()
				if (arrival_day < 10)
					arrival_day = '0' + arrival_day
				let arrival_month = arrival.getMonth() + 1
				if (arrival_month < 10)
					arrival_month = '0' + arrival_month
				const arrival_year = arrival.getFullYear()
				const departure = new Date(stay.departure_time * 1000)
				let departure_day = departure.getDate()
				if (departure_day < 10)
					departure_day = '0' + departure_day
				let departure_month = departure.getMonth() + 1
				if (departure_month < 10)
					departure_month = '0' + departure_month
				const departure_year = departure.getFullYear()
				stay_dates = 'Du ' + arrival_day + '/' + arrival_month + '/' + arrival_year + ' au ' + departure_day + '/' + departure_month + '/' + departure_year
			}
			let location_category = null
			if (arrival_reached && stay && stay.location_category && stay.location_category !== '?')
			{
				let words = stay.location_category.toLowerCase().split(" ")
				for (let i = 0; i < words.length; i++)
					if (words[i].length > 0)
						words[i] = words[i][0].toUpperCase() + words[i].substr(1)
				location_category = (<p className="text-sm text-gray-500 mt-1">{words.join(" ")}</p>)
			}
			let no_stay = null
			if (!stay || !stay.stay_number || stay.stay_number === '?')
			{
				no_stay = (
					<div className="rounded-md bg-gray-50 p-4 mt-6 text-sm text-gray-500">
						Aucune réservation n'est associée à votre compte pour le moment.
					</div>
				)
			}
			// Avatar à initiales
			let initials = ((user.firstname || '?').charAt(0) + (user.lastname || '').charAt(0)).toUpperCase()
			let logoutJSX = (
				<button onClick={this.logout} style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }} className="w-full flex items-center justify-center gap-2 py-2.5 px-4 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
					<LogoutIcon className="h-5 w-5" aria-hidden="true" />
					{lang_assets.logout}
				</button>
			)
			let infosJSX = null
			if (stay_dates || location_category)
			{
				infosJSX = (
					<div className="min-w-0">
						{stay_dates &&
							<p className="text-sm text-gray-500">{stay_dates}</p>
						}
						{location_category}
					</div>
				)
			}
			// Détection d'un changement dans le formulaire
			const isDirty = (
				(this.state.form1.firstname || '') !== (this.state.user.firstname || '') ||
				(this.state.form1.lastname || '') !== (this.state.user.lastname || '') ||
				(this.state.form1.birthday || '') !== (this.state.user.birthday || '') ||
				(this.state.form1.civility || '') !== (this.state.user.civility || '') ||
				(this.state.form1.lang || '') !== (this.state.user.langage || '')
			)
			let actionsJSX = null
			if (isDirty)
			{
				actionsJSX = (
					<div className="pt-5">
						<div className="flex justify-end gap-3">
							<button type="button" onClick={this.handleCancel} style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }} className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
								{lang_assets.stay.cancel_button}
							</button>
							<button type="submit" disabled={this.state.saving} style={{ backgroundImage: 'none', backgroundColor: color1, opacity: this.state.saving ? 0.7 : 1 }} className="inline-flex items-center justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
								{this.state.saving &&
									<svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
										<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
										<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
									</svg>
								}
								{lang_assets.stay.save_button}
							</button>
						</div>
					</div>
				)
			}
			let user_data_JSX = (
				<div>
					<h2 className="text-base leading-6 font-medium mb-4" style={color}>{lang_assets.infos.title}</h2>
					{no_stay}
					<form onSubmit={this.handleSubmit}>
						<div className="space-y-6 sm:space-y-5 mt-5">
							<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
								<label htmlFor="account-lastname" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
									{lang_assets.infos.lastname}
								</label>
								<div className="mt-1 sm:mt-0 sm:col-span-2">
									<input
										id="account-lastname"
										type="text"
										value={this.state.form1.lastname}
										onChange={this.handleLastname}
										className="max-w-lg block w-full shadow-sm focus:ring-gray-400 focus:border-gray-400 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
									/>
								</div>
							</div>
							<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
								<label htmlFor="account-firstname" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
									{lang_assets.infos.firstname}
								</label>
								<div className="mt-1 sm:mt-0 sm:col-span-2">
									<input
										id="account-firstname"
										type="text"
										value={this.state.form1.firstname}
										onChange={this.handleFirstname}
										className="max-w-lg block w-full shadow-sm focus:ring-gray-400 focus:border-gray-400 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
									/>
								</div>
							</div>
							<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
								<label htmlFor="account-email" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
									{lang_assets.infos.email}
								</label>
								<div className="mt-1 sm:mt-0 sm:col-span-2">
									<div className="relative max-w-lg sm:max-w-xs">
										<input
											id="account-email"
											disabled
											type="text"
											value={this.state.form1.email}
											className="block w-full pr-10 shadow-sm sm:text-sm border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed"
										/>
										<LockClosedIcon className="h-4 w-4 text-gray-400 absolute right-3 top-2.5 pointer-events-none" aria-hidden="true" />
									</div>
									<p className="mt-1 text-xs text-gray-400 max-w-lg sm:max-w-xs">{lang_assets.infos.email_locked}</p>
								</div>
							</div>
							<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
								<label htmlFor="account-birthday-day" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
									{lang_assets.infos.birthday}
								</label>
								<div className="mt-1 sm:mt-0 sm:col-span-2">
									{(() => {
										const parts = (this.state.form1.birthday || '').split('/')
										const bdDay = parts[0] || ''
										const bdMonth = parts[1] || ''
										const bdYear = parts[2] || ''
										return (
											<div className="flex items-center gap-2">
												<input
													id="account-birthday-day"
													ref={this.birthdayDayRef}
													type="text"
													inputMode="numeric"
													value={bdDay}
													onChange={this.handleBirthdayDay}
													onKeyDown={(e) => this.handleBirthdayKeyDown(e, 'day')}
													placeholder="JJ"
													maxLength={2}
													className="w-14 text-center shadow-sm focus:ring-gray-400 focus:border-gray-400 sm:text-sm border-gray-300 rounded-md"
												/>
												<span className="text-gray-400 font-medium">/</span>
												<input
													ref={this.birthdayMonthRef}
													type="text"
													inputMode="numeric"
													value={bdMonth}
													onChange={this.handleBirthdayMonth}
													onKeyDown={(e) => this.handleBirthdayKeyDown(e, 'month')}
													placeholder="MM"
													maxLength={2}
													className="w-14 text-center shadow-sm focus:ring-gray-400 focus:border-gray-400 sm:text-sm border-gray-300 rounded-md"
												/>
												<span className="text-gray-400 font-medium">/</span>
												<input
													ref={this.birthdayYearRef}
													type="text"
													inputMode="numeric"
													value={bdYear}
													onChange={this.handleBirthdayYear}
													onKeyDown={(e) => this.handleBirthdayKeyDown(e, 'year')}
													placeholder="AAAA"
													maxLength={4}
													className="w-20 text-center shadow-sm focus:ring-gray-400 focus:border-gray-400 sm:text-sm border-gray-300 rounded-md"
												/>
											</div>
										)
									})()}
								</div>
							</div>
							<div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
								<label htmlFor="account-civility" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
									{lang_assets.infos.civility}
								</label>
								<div className="mt-1 sm:mt-0 sm:col-span-2">
									<select
										id="account-civility"
										value={this.state.form1.civility}
										onChange={this.handleCivility}
										className="max-w-lg block focus:ring-gray-400 focus:border-gray-400 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
									>
										<option value=""></option>
										<option value="man">{lang_assets.infos.man}</option>
										<option value="woman">{lang_assets.infos.woman}</option>
										<option value="other">{lang_assets.infos.other}</option>
									</select>
								</div>
							</div>
							{langJSX}
						</div>
						{success}
						{error}
						{actionsJSX}
					</form>
				</div>
			)
			if (user.invite === true)
			{
				logoutJSX = null
				staysJSX = null
				initials = "?"
				infosJSX = (
					<div className="ml-4 min-w-0">
						<p className="text-xl font-semibold text-gray-900">Mode invité</p>
					</div>
				)
				let show_langJSX = null
				if (langJSX !== null)
				{
					show_langJSX = (
						<form onSubmit={this.handleSubmit}>
							<div className="space-y-6 sm:space-y-5 mt-5">
								{langJSX}
							</div>
							{success}
							{error}
							<div className="pt-5">
								<div className="flex justify-end">
									<button type="submit" style={{ backgroundImage: 'none', backgroundColor: color1 }} className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
										{lang_assets.stay.save_button}
									</button>
								</div>
							</div>
						</form>
					)
				}
				user_data_JSX = (
					<div className="space-y-3">
						<div className="rounded-xl bg-gray-50 px-5 py-5 flex items-center justify-between gap-3">
							<p className="text-base font-medium text-gray-900">{lang_assets.stay.subscribe_msg}</p>
							<Link to="/inscription" style={{ backgroundColor: color1 }} className="inline-flex flex-shrink-0 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white cursor-pointer">
								{lang_assets.stay.subscribe_action}
							</Link>
						</div>
						<div className="rounded-xl bg-gray-50 px-5 py-5 flex items-center justify-between gap-3">
							<p className="text-base font-medium text-gray-900">{lang_assets.stay.signin_msg}</p>
							<Link to="/connexion" style={{ backgroundColor: color1 }} className="inline-flex flex-shrink-0 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white cursor-pointer">
								{lang_assets.stay.signin_action}
							</Link>
						</div>
						{show_langJSX}
					</div>
				)
			}
			return (
				<div className="min-h-4/5-screen">
					<div className="z-0 w-full fixed top-0 h-44 flex items-center px-5 pb-4" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
						<div className="flex items-center gap-4 mt-2">
							<div className="flex items-center justify-center h-14 w-14 rounded-full text-white text-xl font-semibold flex-shrink-0 bg-white bg-opacity-20">
								{initials}
							</div>
							<div className="min-w-0">
								<h1 className="text-white text-2xl font-bold truncate">{lang_assets.greeting} {user.firstname} 👋</h1>
								{statusPill}
							</div>
						</div>
					</div>
					<div className="bg-white w-full pt-10 px-5 mt-40 min-h-9/10-screen absolute rounded-t-3xl pb-10">
						<div className="space-y-8">
							{infosJSX}
							{staysJSX}
							{user_data_JSX}
							<div className="space-y-4 pt-2">
								{logoutJSX}
								<p className="text-center text-xs text-gray-400">
									{lang_assets.about.version}: {version}
								</p>
							</div>
						</div>
					</div>
					<ShareApp
						open={this.state.show_share}
						onClose={this.closeShare}
						user={user}
						app_name={this.props.app_name}
						app_url={this.props.app_url}
						logo={this.props.logo}
						theme={this.props.theme}
						lang_assets={lang_assets.share}
						fetchClientByNumber={this.props.fetchClientByNumber}
					/>
				</div>
			)
		}
	}
}

export default Membres
